import { render, staticRenderFns } from "./sellersPriceModal.vue?vue&type=template&id=742d4aec&scoped=true"
import script from "./sellersPriceModal.vue?vue&type=script&lang=js"
export * from "./sellersPriceModal.vue?vue&type=script&lang=js"
import style0 from "./sellersPriceModal.vue?vue&type=style&index=0&id=742d4aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d4aec",
  null
  
)

export default component.exports